import { Mobile_Apps } from "./Mobile_Apps";

export class Agencies {
    coffee: any;
    filter(arg0: (agency: any) => void): any {
      throw new Error('Method not implemented.');
    }
    id: number;
    name: string;
    description: string;
    adresse: string;
    role: string;
    phone_number: number;
    phone_number2: number;
    phone_number_commercial: number;
    email: string;
    region: string;
    categorie: string;
    sous_categorie: string;
    website_url: string;
    facebook_url: string;
    instagram_url: string;
    linkedin_url: string;
    twitter_url: string;
    tiktok_url: string;          // TikTok
    logo_url: string;
    videoUrl: string;
    videoUrl2: string;
    enableFacebookShare: boolean;
    enableWhatsAppShare: boolean;
    enableMessengerShare: boolean;
    defaultShareMessage: string;
    agencyPublicUrl: string;
    mobile_apps: Mobile_Apps[];
    publicShareMessage: string;
    
    // ✅ Nouveau champ : sous-domaine personnalisé
    subdomain: string;

    constructor() {
        this.id = 0;
        this.logo_url = '';
        this.name = '';
        this.description = '';
        this.adresse = '';
        this.role = '';
        this.region = '';
        this.phone_number = 0;
        this.phone_number2 = 0;
        this.phone_number_commercial = 0;
        this.email = '';
        this.tiktok_url = '';
        this.subdomain = '';      // ✅ Initialisation
        this.enableFacebookShare = true;
        this.enableWhatsAppShare = true;
        this.enableMessengerShare = true;
        this.publicShareMessage = '';
        this.agencyPublicUrl = '';
    }

    static parseBoolean(value: any): boolean {
        if (typeof value === 'boolean') return value;
        if (typeof value === 'string') {
            const str = value.toLowerCase().trim();
            return str === 'true' || str === '1' || str === 'yes' || str === 'on';
        }
        if (typeof value === 'number') return value !== 0;
        return false;
    }
}